<template>
	<button :class="{'Button':true, 'primary': primary, 'Button--icon':$slots.icon}" :type="type" :disabled="button_disabled" @click="onClick()">
		<span v-if="$slots.icon" class="Button__icon"><slot name="icon"></slot></span>
		<slot />
	</button>
</template>

<script>
	export default {
		data() {
			return {
				button_disabled: false
			};
		},

		props: {
			type: {
				type: String,
				default: 'button',
			},
			primary: {
				type: Boolean,
				default: false,
			},
			disabled: {
				type: Boolean,
				default: false,
			},
		},

		mounted() {
			this.button_disabled = this.disabled;
		},

		watch: {
			disabled(value) {
				this.button_disabled = value;
			},
		},

		methods: {
			onClick() {
				if (!this.button_disabled) {
					this.$emit('click', this);
				}
			},

			disable() {
				this.button_disabled = true;
			},

			enable() {
				this.button_disabled = false;
			}
		}
	};
</script>
